import {createEipDocument} from '../../api/documents'
import getToken from '../account/getToken'

// We will need the store very soon to get the JWT and send it in the request
export default store => async document => {
  const token = await getToken(store)()

  return createEipDocument({token, document}).then(response => {
    if (response.status !== 200) {
      throw 'eip_document_create_error'
    }

    return response.json()
  })
}
